import { useDispatch, useSelector } from "react-redux";
import DealerDetails from "./DealerDetails";
import validateDealerDetails from "./DealerDetailsValidation"
import { formatPrice } from "utils";
import { useEffect, useState } from "react";
import { getVendorDetails } from 'Store/Organization/VendorDetails/VendorDetailsAction';
import { setOrderData } from "Store/Component/BulkOrder/BulkOrderAction";

const DealerDetailsContainer = (props: any) => {
  const { requestIndex, catalogItem: reason } = props
  const dispatch = useDispatch();

  const { vendorDetails,
    orderDetails
  }: any = useSelector((state?: any) => ({
    vendorDetails: state.VendorDetailsReducer.vendorDropDownList,
    orderDetails: state.BulkOrderReducer.orderDetails,
  }));

  const [vendorDropdownList, setVendorDropdownList] = useState<any>([]);
  const [loaded, setLoaded] = useState<any>(false);

  const [vendorSearchText, setVendorSearchText] = useState<string>("");
  const [vendor, setVendor] = useState<any>();

  useEffect(() => {
    dispatch(getVendorDetails(""));
    setLoaded(true);
    setVendor({});
  }, [])

  useEffect(() => {
    ///Modified dropDown values as required
    const list = vendorDetails?.map((item: any) =>
      ({ text: item.alphaName, value: item.alphaName, label: item.abnumber + "-" + item.alphaName, key: item.abnumber, ...item })
    );

    setVendorDropdownList(list);
  }, [vendorDetails])


  const handleQuotePriceChange = (event: any) => {
    const value = event.target.value;
    const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
      if (vehicleRequest?.requestIndex === requestIndex) {
        const tempCatalogItems = JSON.parse(JSON.stringify(vehicleRequest?.selectedCatalogItems))?.map((catalogItem: any) => {
          if (catalogItem?.equipmentIndex === reason?.equipmentIndex) {
            return {
              ...catalogItem,
              managedEquipmentDealer: {
                ...catalogItem?.managedEquipmentDealer,
                quotePrice: value,
                estimatedPrice: formatPrice(((parseFloat(value)) / 100) * 10 + parseFloat(value), 2),
                quotePriceError: validateDealerDetails.validateQuotePrice({ ...catalogItem.managedEquipmentDealer, quotePrice: value })?.dealer?.quotePriceError
              }
            }
          }
          return catalogItem
        })
        vehicleRequest.selectedCatalogItems = tempCatalogItems
        return vehicleRequest
      }
      return vehicleRequest
    })
    dispatch(setOrderData(tempOrderData))
  }

  const quotePriceFormat = (event: any) => {
    const value = event.target.value;
    const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
      if (vehicleRequest?.requestIndex === requestIndex) {
        const tempCatalogItems = JSON.parse(JSON.stringify(vehicleRequest?.selectedCatalogItems))?.map((catalogItem: any) => {
          if (catalogItem?.equipmentIndex === reason?.equipmentIndex) {
            return {
              ...catalogItem,
              calculatedPrice: parseFloat(catalogItem?.managedEquipmentDealer?.estimatedPrice?.replace(/,/g, "")),
              managedEquipmentDealer: {
                ...catalogItem?.managedEquipmentDealer,
                quotePrice: formatPrice(value, 2),
              }
            }
          }
          return catalogItem
        })
        vehicleRequest.selectedCatalogItems = tempCatalogItems
        return vehicleRequest
      }
      return vehicleRequest
    })
    dispatch(setOrderData(tempOrderData))
  };

  const handleChange = (e: any) => {
    let name = e?.target?.name
    let value = e?.target?.value
    const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
      if (vehicleRequest?.requestIndex === requestIndex) {
        const tempCatalogItems = JSON.parse(JSON.stringify(vehicleRequest?.selectedCatalogItems))?.map((catalogItem: any) => {
          if (catalogItem?.equipmentIndex === reason?.equipmentIndex) {
            catalogItem.managedEquipmentDealer = validateDealerDetails.validateDealer({ ...catalogItem.managedEquipmentDealer, [name]: value })?.dealer
            return catalogItem
          }
          return catalogItem
        })
        vehicleRequest.selectedCatalogItems = tempCatalogItems
        return vehicleRequest
      }
      return vehicleRequest
    })
    dispatch(setOrderData(tempOrderData))

  }

  const onChangeVendorName = (item: any) => {
    setVendor(item);
    const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
      if (vehicleRequest?.requestIndex === requestIndex) {
        const tempCatalogItems = JSON.parse(JSON.stringify(vehicleRequest?.selectedCatalogItems))?.map((catalogItem: any) => {
          if (catalogItem?.equipmentIndex === reason?.equipmentIndex) {
            catalogItem.managedEquipmentDealer.dealerName = item.label
            catalogItem.managedEquipmentDealer.dealerNameError = ""
            catalogItem.managedEquipmentDealer.dealerContact = item.mailingName
            catalogItem.managedEquipmentDealer.dealerContactError = ""
            catalogItem.managedEquipmentDealer.dealerPhone = item.phoneAreaCode + item.phoneNumber
            catalogItem.managedEquipmentDealer.dealerPhoneError = ""
            catalogItem.managedEquipmentDealer.dealerEmail = ""
            catalogItem.managedEquipmentDealer.dealerEmailError = ""
            catalogItem.managedEquipmentDealer.dealerAdd1 = item.address1
            catalogItem.managedEquipmentDealer.dealerAdd1Error = ""
            catalogItem.managedEquipmentDealer.dealerAdd2 = item.address2
            catalogItem.managedEquipmentDealer.dealerAdd2Error = ""
            catalogItem.managedEquipmentDealer.dealerAdd3 = item.address3
            catalogItem.managedEquipmentDealer.dealerCity = item.city
            catalogItem.managedEquipmentDealer.dealerCityError = ""
            catalogItem.managedEquipmentDealer.dealerState = item.state
            catalogItem.managedEquipmentDealer.dealerStateError = ""
            catalogItem.managedEquipmentDealer.dealerZip = item.postalCode
            catalogItem.managedEquipmentDealer.dealerZipError = ""
            catalogItem.managedEquipmentDealer = validateDealerDetails.validateName(catalogItem.managedEquipmentDealer).dealer
            return catalogItem
          }
          return catalogItem
        })
        vehicleRequest.selectedCatalogItems = tempCatalogItems
        return vehicleRequest
      }
      return vehicleRequest
    })
    dispatch(setOrderData(tempOrderData))
    setVendorSearchText('')
    dispatch(getVendorDetails(''))
  }

  const filterOptionVendor = (value: any, action: any) => {
    if (action.action === "input-change") {
      setVendorSearchText(value)
    }
  };


  const dealerSelectOnBlur = () => {
    setVendorSearchText('')
  }

  useEffect(() => {
    if (loaded && vendorSearchText?.length > 2) {
      dispatch(getVendorDetails(vendorSearchText.replace(/[^\w\s]/gi, "")));
    } else {
      dispatch(getVendorDetails(''))
    }
  }, [vendorSearchText])

  useEffect(() => {
    if (reason?.managedEquipmentDealer?.dealerName) {
      setVendor({ label: reason?.managedEquipmentDealer?.dealerName, text: reason?.managedEquipmentDealer?.dealerName.slice((reason?.managedEquipmentDealer?.dealerName.indexOf('-')) + 1), value: reason?.managedEquipmentDealer?.dealerName.slice((reason?.managedEquipmentDealer?.dealerName.indexOf('-')) + 1) })
    }
    else {
      setVendor("")
    }
  }, [reason?.managedEquipmentDealer?.dealerName])

  const [showDealerVendorPopup, setShowDealerVendorPopup] = useState(false)
  const dealerVendorPopupClick = (e:any) => {
    e.preventDefault();
    setShowDealerVendorPopup(true)
  }

  return (
    <DealerDetails
      reason={reason?.managedEquipmentDealer}
      handleQuotePriceChange={handleQuotePriceChange}
      quotePriceFormat={quotePriceFormat}
      showDealerVendorPopup={showDealerVendorPopup}
      dealerVendorPopupClick={dealerVendorPopupClick}
      setShowDealerVendorPopup={setShowDealerVendorPopup}
      vendorDropdownList={vendorDropdownList}
      onChangeVendorName={onChangeVendorName}
      filterOptionVendor={filterOptionVendor}
      vendor={vendor}
      dealerSelectOnBlur={dealerSelectOnBlur}
      vendorSearchText={vendorSearchText}
      handleChange={handleChange}
    />
  )
}
export default DealerDetailsContainer;